// src/services/dividendService.js
import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return token
    ? {
        Authorization: `JWT ${token}`,
      }
    : {};
};

const parseError = async (response) => {
  try {
    const payload = await response.json();
    if (payload?.detail) return payload.detail;
    if (Array.isArray(payload)) return payload.join(" ");
    if (typeof payload === "object") {
      return Object.entries(payload)
        .map(([field, messages]) =>
          Array.isArray(messages) ? `${field}: ${messages.join(" ")}` : `${field}: ${messages}`
        )
        .join("\n");
    }
  } catch (_err) {
    // Ignore JSON parse issues; fall back to status text.
  }
  return response.statusText || "Unable to complete request.";
};

const apiRequest = async (endpoint, options = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...authHeaders(),
    ...(options.headers || {}),
  };

  const response = await fetch(`${domain}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const fetchDividendRuns = () => apiRequest("dividends/");

export const fetchDividendRunDetail = (runId) => apiRequest(`dividends/${runId}/`);

export const previewDividendRun = (payload) =>
  apiRequest("dividends/run/preview/", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const executeDividendRun = (payload) =>
  apiRequest("dividends/run/execute/", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const fetchMyDividendPayouts = () => apiRequest("dividends/my-payouts/");
